<template>
    <div class="wrapper">
      <header class="bg">
        <h2>UED-CDN</h2>
        <div class="logo-page"><img src="../assets/images/javascript.png" /></div>
        <p>html2canvas</p>
      </header>
      <section>
        <file-list :fileList="fileList"></file-list>
      </section>
    </div>
  </template>

<script>
const ur = "https://uedcdn.zto.com/static/html2canvas";
const versions = [
  '1.4.1'
]
export default {
  name: "index",
  data() {
    return {
      fileList: versions.map(v => ({
        label: v,
        linkList: [
          `${ur}/${v}/html2canvas.js`,
          `${ur}/${v}/html2canvas.min.js`
        ]
      }))
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ListHtml2canvas.vue